"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAsset = void 0;
var react_1 = require("react");
var find_1 = require("@phantom/ph-client-common/utils/find");
var useAsset = function (assets, type, def) {
    return (0, react_1.useMemo)(function () { return (0, find_1.getValueByType)(assets, type) || def; }, [assets, def]);
};
exports.useAsset = useAsset;
